import Dropdown from './Dropdown';
import LoginButton from './LoginButton';


const Navbar = () => {
    return (
        <div className="flex justify-between flex-row relative items-center bg-white z-50 mx-4 my-2">
            <img src="https://klbtheme.com/movify/wp-content/uploads/2018/04/logo.png" />
            <div className="flex items-center">
                <Dropdown></Dropdown>
                <h6 className="text-sm font-medium text-gray-600">Contact Us</h6>
            </div>
            <div className="flex">
                <LoginButton></LoginButton>
            </div>
        </div >
    )
}

export default Navbar;